export const ISSUE_VIEW_SECTION = {
	OVERVIEW: 'overview',
	COMMENTS: 'comments',
	CAPTURE: 'capture', // This is the current Insights
	FEEDBACK_INSIGHTS: 'insights', // THIS IS NEW FEEDBACK INSIGHTS
	DELIVER: 'deliver',
	DELIVER_CREATE: 'deliver_create',
	DELIVER_LINK: 'deliver_link',
	HISTORY: 'history',
	CONNECTIONS: 'connections',
} as const;

export const ISSUE_VIEW_SECTIONS: (
	| 'overview'
	| 'comments'
	| 'capture'
	| 'insights'
	| 'deliver'
	| 'deliver_create'
	| 'deliver_link'
	| 'history'
	| 'connections'
)[] = Object.values(ISSUE_VIEW_SECTION);

export type IssueViewSection = (typeof ISSUE_VIEW_SECTIONS)[number];
